._message-ai_idlxd_1,
._message-user_idlxd_2 {
  padding: 21px 24px;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  border-radius: 12px;
  margin-bottom: 12px;
  box-shadow: var(--chat-message-drop-shadow); }

@container chat (max-width: 470px) {
  ._message-ai_idlxd_1,
  ._message-user_idlxd_2 {
    margin-bottom: 9px; } }
  [data-theme="chat-theme-dark"] ._message-ai_idlxd_1,
  [data-theme="chat-theme-light"] ._message-ai_idlxd_1, [data-theme="chat-theme-dark"]
  ._message-user_idlxd_2,
  [data-theme="chat-theme-light"]
  ._message-user_idlxd_2 {
    padding: 30px 36px 30px 24px; }
  ._message-ai_idlxd_1._message-box_idlxd_23,
  ._message-user_idlxd_2._message-box_idlxd_23 {
    min-height: 85px;
    flex-direction: row !important; }

@container chat (max-width: 470px) {
  ._message-ai_idlxd_1._message-box_idlxd_23,
  ._message-user_idlxd_2._message-box_idlxd_23 {
    min-height: 84px; } }
    ._message-ai_idlxd_1._message-box_idlxd_23 ._user-name_idlxd_32,
    ._message-user_idlxd_2._message-box_idlxd_23 ._user-name_idlxd_32 {
      display: none !important; }

@container chat (max-width: 470px) {
  ._message-ai_idlxd_1,
  ._message-user_idlxd_2 {
    padding: 12px;
    gap: 4px; }
    ._message-ai_idlxd_1._message-box_idlxd_23,
    ._message-user_idlxd_2._message-box_idlxd_23 {
      flex-direction: column !important; }
      ._message-ai_idlxd_1._message-box_idlxd_23 ._user-name_idlxd_32,
      ._message-user_idlxd_2._message-box_idlxd_23 ._user-name_idlxd_32 {
        line-height: 26px !important;
        font-weight: 500 !important;
        display: block !important; }
        [data-theme="chat-theme-dark"] ._message-ai_idlxd_1._message-box_idlxd_23 ._user-name_idlxd_32,
        [data-theme="chat-theme-light"] ._message-ai_idlxd_1._message-box_idlxd_23 ._user-name_idlxd_32, [data-theme="chat-theme-dark"]
        ._message-user_idlxd_2._message-box_idlxd_23 ._user-name_idlxd_32,
        [data-theme="chat-theme-light"]
        ._message-user_idlxd_2._message-box_idlxd_23 ._user-name_idlxd_32 {
          font-size: 11px; }
        [data-theme="chat-theme-dark"] ._message-ai_idlxd_1._message-box_idlxd_23 ._user-name_idlxd_32, [data-theme="chat-theme-dark"]
        ._message-user_idlxd_2._message-box_idlxd_23 ._user-name_idlxd_32 {
          color: #babac2 !important; }
        [data-theme="chat-theme-light"] ._message-ai_idlxd_1._message-box_idlxd_23 ._user-name_idlxd_32, [data-theme="chat-theme-light"]
        ._message-user_idlxd_2._message-box_idlxd_23 ._user-name_idlxd_32 {
          color: #868aa5 !important; }
    [data-theme="chat-theme-dark"] ._message-ai_idlxd_1,
    [data-theme="chat-theme-light"] ._message-ai_idlxd_1, [data-theme="chat-theme-dark"]
    ._message-user_idlxd_2,
    [data-theme="chat-theme-light"]
    ._message-user_idlxd_2 {
      padding: 14px 16px; }
    ._message-ai_idlxd_1._widget-box_idlxd_67,
    ._message-user_idlxd_2._widget-box_idlxd_67 {
      padding: 14px 16px;
      opacity: 0;
      animation: _fadeIn_idlxd_1 0s ease-out 0.5s forwards; } }

@keyframes _fadeIn_idlxd_1 {
  from {
    transform: translateY(-1em);
    opacity: 0; }
  to {
    transform: translateY(0);
    opacity: 1; } }
  ._message-ai_idlxd_1 ._user-avatar_idlxd_80,
  ._message-user_idlxd_2 ._user-avatar_idlxd_80 {
    min-width: 30px;
    width: 30px;
    height: 30px;
    margin: -4px 8px 0 -8px;
    display: block; }
    [data-theme="chat-theme-dark"] ._message-ai_idlxd_1 ._user-avatar_idlxd_80,
    [data-theme="chat-theme-light"] ._message-ai_idlxd_1 ._user-avatar_idlxd_80, [data-theme="chat-theme-dark"]
    ._message-user_idlxd_2 ._user-avatar_idlxd_80,
    [data-theme="chat-theme-light"]
    ._message-user_idlxd_2 ._user-avatar_idlxd_80 {
      transform: scale(0.8);
      margin: -4px 8px 0 -3px; }

@container chat (max-width: 470px) {
  ._message-ai_idlxd_1 ._user-avatar_idlxd_80,
  ._message-user_idlxd_2 ._user-avatar_idlxd_80 {
    height: 24px;
    margin: -2px 6px 0 -4px;
    width: 24px;
    transform: scale(0.8); }
    [data-theme="chat-theme-dark"] ._message-ai_idlxd_1 ._user-avatar_idlxd_80,
    [data-theme="chat-theme-light"] ._message-ai_idlxd_1 ._user-avatar_idlxd_80, [data-theme="chat-theme-dark"]
    ._message-user_idlxd_2 ._user-avatar_idlxd_80,
    [data-theme="chat-theme-light"]
    ._message-user_idlxd_2 ._user-avatar_idlxd_80 {
      margin: -1px 8px 0 -6px;
      transform: scale(0.6); } }

._ai-avatar-image_idlxd_110 {
  background: var(--asisstant-image-url);
  min-width: 30px;
  height: 30px;
  margin: -5px 6px 0 -4px; }
  [data-theme="chat-theme-light"] ._ai-avatar-image_idlxd_110 {
    background-size: 29px;
    background-position: 1px 2px; }
  [data-theme="chat-theme-dark"] ._ai-avatar-image_idlxd_110 {
    background-size: 23px;
    background-position: 4px 5px; }

@container chat (max-width: 470px) {
  ._ai-avatar-image_idlxd_110 {
    margin: -3px 6px 0 -4px; }
    [data-theme="chat-theme-light"] ._ai-avatar-image_idlxd_110 {
      background-size: 21px;
      background-position: 3px 2px; }
    [data-theme="chat-theme-dark"] ._ai-avatar-image_idlxd_110 {
      background-size: 17px;
      background-position: 5px 4px; } }

._aiAvatarImageLoading_idlxd_132 {
  position: absolute;
  opacity: 0;
  transform: scale(0);
  transform-origin: 50% 50%;
  transition: 0.3s; }

@container chat (max-width: 470px) {
  ._aiAvatarImageLoading_idlxd_132 {
    top: 1px; } }
  ._aiAvatarImageLoadingVisible_idlxd_142 {
    opacity: 1; }

._message-ai_idlxd_1 {
  align-self: flex-start; }

@container chat (max-width: 470px) {
  [data-theme="chat-theme-dark"] ._message-ai_idlxd_1 ._user-name_idlxd_32,
  [data-theme="chat-theme-light"] ._message-ai_idlxd_1 ._user-name_idlxd_32 {
    line-height: 21px !important; } }
  ._message-ai_idlxd_1 ._ai-avatar_idlxd_110 {
    background: white; }

@container chat (min-width: 470px) {
  [data-theme="chat-theme-original"] ._message-ai_idlxd_1 ._imageWrapper_idlxd_156 {
    margin-right: 5px; }
  [data-theme="chat-theme-dark"] ._message-ai_idlxd_1 ._imageWrapper_idlxd_156,
  [data-theme="chat-theme-light"] ._message-ai_idlxd_1 ._imageWrapper_idlxd_156 {
    margin-right: 10px; } }

._message-user_idlxd_2 {
  align-self: flex-end;
  will-change: opacity, transform;
  animation: _userMessageEntrance_idlxd_1 0.5s forwards;
  background: var(--chat-message-user-bg-color); }
  ._message-user_idlxd_2 ._ai-avatar_idlxd_110 {
    width: 30px;
    min-width: 30px;
    height: 30px;
    margin-right: 13px;
    margin-left: -3px;
    transform: translateY(-4px); }

@container chat (max-width: 470px) {
  ._message-user_idlxd_2 ._ai-avatar_idlxd_110 {
    height: 24px;
    min-width: 24px;
    margin-right: 0px; } }

._widgets_idlxd_181 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%; }

._imageWrapper_idlxd_156 {
  transition: 0.3s;
  transform-origin: 20% 50%;
  margin-right: 7px; }

@container chat (max-width: 470px) {
  ._imageWrapper_idlxd_156 {
    margin-right: 0; } }

._noPadding_idlxd_196 {
  padding: 0; }

._userNonTypedText_idlxd_199 {
  color: var(--text-color) !important; }

@keyframes _userMessageEntrance_idlxd_1 {
  0% {
    opacity: 0;
    transform: translateY(1em); }
  100% {
    opacity: 1;
    transform: translateY(0); } }

@container chat (max-width: 470px) {
  ._widget_idlxd_67 ._name-box_idlxd_211 {
    display: none; } }

._name-box_idlxd_211 {
  position: relative; }

@container chat (max-width: 470px) {
  ._name-box_idlxd_211 ._name-box_idlxd_211 {
    margin-bottom: 6px; }
    [data-theme="chat-theme-dark"] ._name-box_idlxd_211 ._name-box_idlxd_211,
    [data-theme="chat-theme-light"] ._name-box_idlxd_211 ._name-box_idlxd_211 {
      margin-bottom: 5px; } }

._loading_idlxd_224 ._imageWrapper_idlxd_156 {
  transform: scale(0); }

._loading_idlxd_224 ._aiAvatarImageLoading_idlxd_132 {
  transform: scale(1); }
